import axios from 'axios';

export const REST_API = 'https://sp.demoapi.v2.hyperthings.in/api/v1/';

// axios implementation
export const fetcher = axios.create({
  baseURL: REST_API,
  timeout: 13000,
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
});

const token =
  'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6ImY4MTA4ZDI3LTI2YzktNDRlMS1hNjcxLWQzYjQyOTAyNjhiNyIsIm1vYmlsZSI6Ijk3OTE0MjY2ODEiLCJpc0FjdGl2ZSI6dHJ1ZSwicm9sZV9pZCI6IjM5MyIsImlhdCI6MTY4MzYyMDAxOCwiZXhwIjoxOTA0NTIzMjE4fQ.st-yi6vYXS_DdePbs6xYEAi7MGUM57oi76uvL3mmqMo';
export const fetcherWithToken = axios.create({
  baseURL: REST_API,
  timeout: 13000,
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
    Authorization: `Bearer ${token}`,
  },
});

export const sendRequest = (url, method, body) =>
  fetcher({
    method,
    url,
    data: body,
  }).then((res) => res.data);

export const sendRequestWithToken = (url, method, body) =>
  fetcherWithToken({
    method,
    url,
    data: body,
  }).then((res) => res.data);
